import ProjectScopeDocSidebarWidgetComponent from './scope-doc-sidebar-widget.component'

const ProjectScopeDocSidebarWidgetModule = angular.module('cdbl.scope-doc-sidebar-widget', [

])
  .component('cdblProjectScopeDocSidebarWidget', ProjectScopeDocSidebarWidgetComponent)
  .name

export default ProjectScopeDocSidebarWidgetModule
